export function getTextWidth( text, fontSize, fontFace ) {

    const canvas = document.createElement( 'canvas' ),
        context = canvas.getContext( '2d' );

    context.font = `${ fontSize }px ${ fontFace }`;

    return context.measureText( text ).width;

}